<template>
  <MotionJump :stiffness="460" :damping="40" :delay="0.1">
    <CardContent theme="neutral-50" stroke="n" class="card-error" elevate="all">
      <template #header>
        <heading class="head" align="center" tag="h1">
          <MotionJump
            key="title"
            :x="-500"
            :stiffness="400"
            :damping="40"
            :delay="0.1"
            :scale="1"
          >
            Erreur {{ error.statusCode }}
          </MotionJump>
        </heading>
      </template>

      <MotionJump :stiffness="200" :damping="13" :delay="0.1">
        <icon :name="item1" size="20rem" />
      </MotionJump>

      <p class="description">
        <icon class="hidden-cat" size="4rem" :name="item2"></icon>

        <MotionJump
          :x="500"
          :stiffness="400"
          :scale="1"
          :damping="20"
          :delay="0.4"
        >
          {{ $t('error.page.description') }}
        </MotionJump>
        <MotionJump :stiffness="300" :damping="25" :delay="1.2" :y="200">
          <icon size="4rem" :name="item2"></icon>
        </MotionJump>
      </p>
      <MotionJump
        :stiffness="300"
        :damping="20"
        :delay="0.3"
        :y="200"
        :scale="1"
      >
        <ButtonBase stroke="n" @click="handleClickHome">
          Retour à la page d'accueil
        </ButtonBase>
      </MotionJump>
      <MotionJump
        :stiffness="300"
        :damping="20"
        :delay="0.6"
        :y="200"
        :scale="1"
      >
        <ButtonBase stroke="n" theme="secondary" @click="handleClickReset">
          Recharger votre compte
        </ButtonBase>
      </MotionJump>
    </CardContent>
  </MotionJump>
</template>
<script setup lang="ts">
defineProps({
  error: Object,
});
const handleClickHome = () => clearError({ redirect: '/' });
const handleClickReset = () => {
  window.location.href = '/logout';
};
const icons = [
  'fluent-emoji:cold-face',
  'fluent-emoji:cat-with-wry-smile',
  'fluent-emoji:confounded-face',
  'fluent-emoji:crying-face',
  'fluent-emoji:face-screaming-in-fear',
  'fluent-emoji:fire-engine',
  'fluent-emoji:hushed-face',
  'fluent-emoji:panda',
  'fluent-emoji:pensive-face',
  'fluent-emoji:person-bowing',
  'fluent-emoji:person-genie',
  'fluent-emoji:pig-nose',
  'fluent-emoji:pleading-face',
  'fluent-emoji:smiling-face-with-horns',
  'fluent-emoji:squinting-face-with-tongue',
  'fluent-emoji:unamused-face',
  'fluent-emoji:tired-face',
  'fluent-emoji:upside-down-face',
];
const iconsSamll = [
  'fluent-emoji:cold-face',
  'fluent-emoji:disguised-face',
  'fluent-emoji:dog-face',
  'fluent-emoji:factory-worker-light',
  'fluent-emoji:face-with-symbols-on-mouth',
  'fluent-emoji:hushed-face',
  'fluent-emoji:man-construction-worker-medium-light',
  'fluent-emoji:man-health-worker-light',
  'fluent-emoji:man-in-lotus-position',
  'fluent-emoji:ninja-medium-light',
  'fluent-emoji:ogre',
  'fluent-emoji:panda',
  'fluent-emoji:person-mage',
  'fluent-emoji:rabbit-face',
  'fluent-emoji:polar-bear',
  'fluent-emoji:scientist-medium-dark',
  'fluent-emoji:thinking-face',
  'fluent-emoji:woman-construction-worker',
];

const item1 = icons[Math.floor(Math.random() * icons.length)];
const item2 = iconsSamll[Math.floor(Math.random() * iconsSamll.length)];
</script>
<style lang="scss" scoped>
.card-error {
  position: relative;
  width: calc(100% - 4rem);
  overflow: hidden;
  @include above('l') {
    width: 54rem;
  }
  img {
    border-radius: 0.8rem;
  }
  p {
    @include font('m', 800);

    z-index: 1;
    overflow: hidden;
    color: var(--color_neutral_600);
    text-align: center;
  }
  p,
  .head {
    display: flex;
    z-index: 1;
    align-items: center;
    justify-content: center;
    gap: 1.8rem;
  }
  .head {
    gap: 0;
  }
  .hidden-cat {
    visibility: hidden;
  }
}
</style>
